import { trackInteraction } from ".";

export const interactionEventPages: Record<string, string> = {
  dispensador_home: 'dispensador_home',
  dispensador_detalhes_receita: 'dispensador_detalhes_receita',
}

export const interactionEventCategory = 'dispensador';


export type eventAction = 'display' | 'click' | 'select' | 'download';
export const interactionEventActions: Record<eventAction, eventAction> = {
  display: 'display',
  click: 'click',
  select: 'select',
  download: 'download',
}

export type eventLabel = 'view_anuncio_temporario'
  | 'click_anuncio_temporario'
  | 'close_anuncio_temporario'
  | 'validar_assinatura'
  | 'baixar_prescricao_completa'
  | 'baixar_prescricao_individual'
  | 'dispensar'
  | 'cancelar_dispensacao'
  | 'selecionar_item'
  | 'selecionar_quantidade';

export const interactionEventLabels: Record<eventLabel, eventLabel> = {
  view_anuncio_temporario: 'view_anuncio_temporario',
  click_anuncio_temporario: 'click_anuncio_temporario',
  close_anuncio_temporario: 'close_anuncio_temporario',
  validar_assinatura: 'validar_assinatura',
  baixar_prescricao_completa: 'baixar_prescricao_completa',
  baixar_prescricao_individual: 'baixar_prescricao_individual',
  dispensar: 'dispensar',
  cancelar_dispensacao: 'cancelar_dispensacao',
  selecionar_item: 'selecionar_item',
  selecionar_quantidade: 'selecionar_quantidade',
}

export type TemporaryAnnouncementEventPayload = {
  announcementId: string;
  page: keyof typeof interactionEventPages;
  drugstoreId: number;
  drugstoreUF: string;
  drugstoreName: string;
  chainId: number;
  chainName: string;
}

type TrackViewTemporatyAnnouncementPayload = TemporaryAnnouncementEventPayload;
type TrackClickTemporatyAnnouncementPayload = TemporaryAnnouncementEventPayload;
type TrackCloseTemporatyAnnouncementPayload = TemporaryAnnouncementEventPayload;

export function trackViewTemporatyAnnouncement({
  announcementId,
  page,
  drugstoreId,
  drugstoreUF,
  drugstoreName,
  chainId,
  chainName,
}: TrackViewTemporatyAnnouncementPayload): void {
  trackInteraction({
    page,
    category: interactionEventCategory,
    action: interactionEventActions.display,
    label: interactionEventLabels.view_anuncio_temporario,
    properties: {
      announcement_id: announcementId,
      drugstore_id: drugstoreId,
      drugstore_uf: drugstoreUF,
      drugstore_name: drugstoreName,
      chain_id: chainId,
      chain_name: chainName,
    },
  });
}

export function trackClickTemporatyAnnouncement({
  announcementId,
  page,
  drugstoreId,
  drugstoreUF,
  drugstoreName,
  chainId,
  chainName,
}: TrackClickTemporatyAnnouncementPayload): void {
  trackInteraction({
    page,
    category: interactionEventCategory,
    action: interactionEventActions.click,
    label: interactionEventLabels.click_anuncio_temporario,
    properties: {
      announcement_id: announcementId,
      drugstore_id: drugstoreId,
      drugstore_uf: drugstoreUF,
      drugstore_name: drugstoreName,
      chain_id: chainId,
      chain_name: chainName,
    },
  });
}

export function trackCloseTemporatyAnnouncement({
  announcementId,
  page,
  drugstoreId,
  drugstoreUF,
  drugstoreName,
  chainId,
  chainName,
}: TrackCloseTemporatyAnnouncementPayload): void {
  trackInteraction({
    page,
    category: interactionEventCategory,
    action: interactionEventActions.click,
    label: interactionEventLabels.close_anuncio_temporario,
    properties: {
      announcement_id: announcementId,
      drugstore_id: drugstoreId,
      drugstore_uf: drugstoreUF,
      drugstore_name: drugstoreName,
      chain_id: chainId,
      chain_name: chainName,
    },
  });
}